export const GET_MENU_REQUEST = 'GET_MENU_REQUEST';
export const GET_MENU_SUCCESS = 'GET_MENU_SUCCESS';
export const GET_MENU_FAILURE = 'GET_MENU_FAILURE';
export const SET_ORDER_TYPE = 'SET_ORDER_TYPE';

export const RESET_MENU_REDUCER = 'RESET_MENU_REDUCER';
